import { createSlice } from '@reduxjs/toolkit';
import { getPropertyStarredContacts, sendHoggaxQuoteRequest } from './services';

const initialState = {
  showModal: false,
  quoteRequest: {
    success: false,
    loading: false,
    error: null,
  },
  starredContacts: { loading: false, contacts: [], selected: null },
};

export const HoggaxSlice = createSlice({
  name: 'hoggax',
  initialState,
  reducers: {
    showHoggaxModal(state, action) {
      const { payload } = action;
      state.showModal = payload;
      if (payload === false) {
        state.quoteRequest = initialState.quoteRequest;
      }
    },
    setStarredContact(state, actions) {
      state.starredContacts.selected = actions.payload;
    },
  },
  extraReducers: (builder) => {
    builder // send Hoggax quote request
      .addCase(sendHoggaxQuoteRequest.pending, (state) => {
        state.quoteRequest.loading = true;
      })
      .addCase(sendHoggaxQuoteRequest.fulfilled, (state) => {
        state.quoteRequest.loading = false;
        state.quoteRequest.success = true;
      })
      .addCase(sendHoggaxQuoteRequest.rejected, (state, action) => {
        state.quoteRequest.loading = false;
        state.quoteRequest.error = action.error.message;
        state.showModal = false;
      });
    builder // get property starred contacts
      .addCase(getPropertyStarredContacts.pending, (state) => {
        state.starredContacts.loading = true;
      })
      .addCase(getPropertyStarredContacts.fulfilled, (state, action) => {
        state.starredContacts = {
          contacts: action.payload,
          loading: false,
          selected: null,
        };
      });
  },
});

export const { showHoggaxModal, setStarredContact } = HoggaxSlice.actions;

export default HoggaxSlice.reducer;
